// Public marketing bundle. Loaded only by the `public` layout.
// Admin / IMS pages continue to use importmap.

import { Application } from "@hotwired/stimulus"

import ScrollRevealController from "./controllers/scroll_reveal_controller"
import SmoothScrollController from "./controllers/smooth_scroll_controller"
import MarqueeController      from "./controllers/marquee_controller"
import CounterController      from "./controllers/counter_controller"

import LenisController           from "./public/controllers/lenis_controller"
import WellcodeSceneController   from "./public/controllers/wellcode_scene_controller"
import PortfolioGalleryController from "./public/controllers/portfolio_gallery_controller"
import SceneSectionController    from "./public/controllers/scene_section_controller"
import TextRevealController      from "./public/controllers/text_reveal_controller"
import MagneticController        from "./public/controllers/magnetic_controller"
import IdleMarqueeController     from "./public/controllers/idle_marquee_controller"
import PortfolioTourController   from "./public/controllers/portfolio_tour_controller"
import CaptionThumbsController   from "./public/controllers/caption_thumbs_controller"
import PublicNavController       from "./public/controllers/public_nav_controller"
import SectionCtaController      from "./public/controllers/section_cta_controller"
import MmpCarouselController     from "./public/controllers/mmp_carousel_controller"
import LightSectionController    from "./public/controllers/light_section_controller"

const application = Application.start()
application.debug = false
window.Stimulus = application

application.register("scroll-reveal",     ScrollRevealController)
application.register("smooth-scroll",     SmoothScrollController)
application.register("marquee",           MarqueeController)
application.register("counter",           CounterController)

application.register("lenis",             LenisController)
application.register("wellcode-scene",    WellcodeSceneController)
application.register("portfolio-gallery", PortfolioGalleryController)
application.register("scene-section",     SceneSectionController)
application.register("text-reveal",       TextRevealController)
application.register("magnetic",          MagneticController)
application.register("idle-marquee",      IdleMarqueeController)
application.register("portfolio-tour",    PortfolioTourController)
application.register("caption-thumbs",    CaptionThumbsController)
application.register("public-nav",        PublicNavController)
application.register("section-cta",       SectionCtaController)
application.register("mmp-carousel",      MmpCarouselController)
application.register("light-section",     LightSectionController)
